import { Component } from '@angular/core';

@Component({
  selector: 'app-stock',
  template: `<router-outlet></router-outlet>`,
})
export class StockComponent {}
